import { render } from "./CriteriosScorePanel.vue?vue&type=template&id=ff330ae8&scoped=true"
import script from "./CriteriosScorePanel.vue?vue&type=script&lang=js"
export * from "./CriteriosScorePanel.vue?vue&type=script&lang=js"

import "./CriteriosScorePanel.vue?vue&type=style&index=0&id=ff330ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff330ae8"]])

export default __exports__